import { WelfarePlan, useAuthStore } from '@tundr/auth';
import type { RouteRecordRaw } from 'vue-router';
import { hrRoutesDictionary } from '@modules/app/hr/routes/hr-routes.dictionary.ts';
import { dashboardRoutesDictionary } from './dashboard-routes.dictionary';

export const dashboardRoutesConfig: RouteRecordRaw = {
  ...dashboardRoutesDictionary.dashboard.root,
  redirect: { name: dashboardRoutesDictionary.dashboard.list.name },
  beforeEnter: () => {
    const authStore = useAuthStore();
    if (authStore.currentWelfarePlan !== WelfarePlan.STANDARD) {
      return { name: hrRoutesDictionary.hr.root.name };
    }
    return true;
  },
  children: [
    {
      ...dashboardRoutesDictionary.dashboard.list,
      component: () => import('../pages/DashboardPage/DashboardPage.vue'),
    },
  ],
};
